<template>
  <div class="text-end mb-3">
    <button
      class="btn btn-primary"
      title="Exportar para CSV"
      @click="exportToCSV"
      :disabled="disableButton"
    >
      <span v-if="disableButton">
        Gerando arquivo <i class="ph-spinner spinner" />
      </span>
      <span v-else>Exportar para CSV</span>
    </button>
  </div>
  <div class="card">
    <div class="table-responsive">
      <table
        class="table table-sm table-bordered table-striped"
        id="tableReport"
      >
        <thead class="bg-teal text-white text-center">
          <tr>
            <th colspan="2">Centro de Custo</th>
            <th>Natureza</th>
            <th>Valor Orçado</th>
            <th>Valor Orçado TOTVS</th>
            <th>Valor Final</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(registro, index) in reports" :key="index">
            <td class="fs-smxs">
              {{ registro.codCCustoPai }} - {{ registro.nomeCCustoPai }}
            </td>
            <td class="fs-smxs">
              {{ registro.codCCustoFilho }} - {{ registro.nomeCCustoFilho }}
            </td>
            <td class="fs-smxs">
              {{ registro.codTBOrcamento }} -
              {{ registro.nomeTBOrcamento }}
            </td>
            <td class="fs-smxs text-center">
              {{ moneyToCurrencyBr(registro.valorPropostaWeb) }}
            </td>
            <td class="fs-smxs text-center">
              {{ moneyToCurrencyBr(registro.valorPropostaRM) }}
            </td>
            <td class="fs-smxs text-center">
              {{ moneyToCurrencyBr(registro.valor) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { moneyToCurrencyBr } from '@/utils/strings'
import { JSON2CSV } from '@/utils/functions'
import PeriodoOrcamentoEnum from '@/enum/periodoOrcamentoEnum'

export default {
  name: 'ExportacaoResult',

  props: {
    reports: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      disableButton: false,
      dataExport: [],
      moneyToCurrencyBr,
      PeriodoOrcamentoEnum,
    }
  },

  computed: {
    ...mapGetters(['user']),

    nameFile() {
      return Number(this.filters.periodoOrcamento) ===
        PeriodoOrcamentoEnum.PROPOSTA
        ? 'Orcamento_Proposto.csv'
        : 'Orcamento_Reformulado.csv'
    },
  },

  methods: {
    async exportToCSV() {
      this.disableButton = true
      try {
        this.dataExport = await this.$store.dispatch('relExportacao', {
          orcamentoId: this.filters.orcamentoId,
          periodoOrcamento: this.filters.periodoOrcamento,
          tipoRelatorio: 2,
        })

        JSON2CSV(this.nameFile, this.dataExport)

        this.disableButton = false
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },
}
</script>

<style scoped>
td {
  padding: 0.3rem;
}
</style>
